import * as React from "react";
import {AppTranslations} from "../../components/Utils/translations/AppTranslations";
import {EmptyState, icons} from "@vebox/etui-core";

declare var AppTranslations: AppTranslations;

export const NotAvailableMassiveAction: React.FC<{}> = () => {
    const translations = AppTranslations.massiveActions.massiveActionsCommon
    return (
        <div className={"wrapper"}>
            <EmptyState>
                <EmptyState.Icon size={144} glyph={icons.ERROR_CIRCLE}/>
                <EmptyState.Title color="inherit">
                    {translations.massiveActionNotAvailableTitle}
                </EmptyState.Title>
                <EmptyState.SubTitle color="inherit">
                    {translations.massiveActionNotAvailableDescription}
                </EmptyState.SubTitle>
            </EmptyState>
        </div>
    )
}